import React , {useState} from 'react'
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../../../StyleSheet/AppComponent/InputFields/InputFields.scss";

const Password = (props) => {
    const {value ,onChange , Error , label} = props;
    const [viewpass, setViewpass] = useState(false);
    return (
        <>
            <div className='Outer-Inputs'>
              
                <label >{label}</label>
                <div className='Password inputFields'>
                
                    <input type='text' value={value} name="Password" onChange={onChange}
                     className={`${viewpass ? "activate" : "notactivate"}`} autoComplete='off'
                    />
                     <i className="icon">
                  {viewpass ? (
                    <VisibilityOffIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></VisibilityOffIcon>
                  ) : (
                    <RemoveRedEyeIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></RemoveRedEyeIcon>
                  )}
                </i>
                </div>
                <p style={{color:"red", paddingLeft:"28px"}}  className='Error'>{Error}</p>
            </div>
        </>
    )
}

export default Password
